"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StoryPointInfoImpl {
    constructor(_caption, _index, _storyPointId, _active, _updated, _parentStoryImpl) {
        this._caption = _caption;
        this._index = _index;
        this._storyPointId = _storyPointId;
        this._active = _active;
        this._updated = _updated;
        this._parentStoryImpl = _parentStoryImpl;
    }
    get caption() {
        return this._caption;
    }
    set caption(caption) {
        this._caption = caption;
    }
    get index() {
        return this._index;
    }
    set index(index) {
        this._index = index;
    }
    get storyPointId() {
        return this._storyPointId;
    }
    get active() {
        return this._active;
    }
    set active(isActive) {
        this._active = isActive;
    }
    get updated() {
        return this._updated;
    }
    set updated(isUpdated) {
        this._updated = isUpdated;
    }
    get parentStory() {
        return this._parentStoryImpl;
    }
}
exports.StoryPointInfoImpl = StoryPointInfoImpl;
//# sourceMappingURL=StoryPointInfoImpl.js.map